import { Component, inject } from '@angular/core';
import { AsyncPipe, DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, map, of, startWith, switchMap } from 'rxjs';
import { ApiService } from '../api.service';
import { ParticipantSearchResult, ProjectSearchResult, SearchResult } from '../models';

@Component({
  selector: 'app-global-search',
  standalone: true,
  imports: [AsyncPipe, DatePipe],
  templateUrl: './global-search.html',
  styleUrl: './global-search.scss',
})
export class GlobalSearch {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private api = inject(ApiService);

  // Combined view-model stream with status, query, and results/error
  vm$ = this.route.queryParamMap.pipe(
    map((params) => (params.get('q') ?? '').trim()),
    switchMap((query) => {
      if (!query) {
        return of({ status: 'idle', query } as const);
      }

      return this.api.search(query).pipe(
        map((results: SearchResult) => ({ status: 'success', query, results }) as const),
        startWith({ status: 'loading', query } as const),
        catchError((error) => of({ status: 'error', query, error } as const)),
      );
    }),
  );

  goToParticipant(result: ParticipantSearchResult) {
    this.router.navigate(['projects', result.projectId, 'participants', result.participantId]);
  }

  goToProject(result: ProjectSearchResult) {
    this.router.navigate(['projects', result.projectId]);
  }
}
